module.exports = __webpack_public_path__ + "static/media/200.e79d0a10.jpg";